import {Injectable} from '@angular/core';
import {AbstractFindOneByIdService} from '../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {CommunicationContentModelModel} from '../../api/entity/communicationContentModel.model';
import {CommunicationContentModelRepository} from './ngrx/communicationContentModel.repository';
import {CommunicationContentModelDataServiceAdapter} from './ngrx/communicationContentModelDataService.adapter';

@Injectable()
export class CommunicationContentModelFindOneByIdService
    extends AbstractFindOneByIdService<CommunicationContentModelModel, CommunicationContentModelModel> {

    constructor(repository: CommunicationContentModelRepository, dataServiceAdapter: CommunicationContentModelDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
